// Explicit synthetic preview data. Never used as component defaults.
//
// #583 N1 S12: the gallery previews the report screen in the same shape the live container supplies: ONE
// synthetic stored snapshot, mapped by the same `toReport`, and a family activity list in the D-60 shape
// with the Q4 measure. Every number here is invented for the preview and belongs to no family. The old
// fixture's "Fairness" tile and inferred sentences are gone with the tiles that drew them (design D6).
import { ART_BASE } from '../assets.js';
import { toActivity, toReport } from '../lib/insightsMapping.js';

const ASSET = ART_BASE;
const DAYS = ['2026-09-01', '2026-09-02', '2026-09-03', '2026-09-04', '2026-09-05', '2026-09-06', '2026-09-07'];
const SAVED = [4, 5, 5, 1, 4, 6, 7];
const SETTLED = [null, null, null, null, null, null, '14.50'];
const row = (metric, bin, value, extra = {}) => ({ id: `${metric}:${bin}`, metric, series: metric, bin, value, numerator: null,
  denominator: null, unknown: null, currency: null, profileId: null, coverage: 'full', ...extra });

const FIXTURE_SNAPSHOT = {
  id: '00000000-0000-4000-8000-00000000f1c5',
  asOf: '2026-09-07T23:00:00.000000Z',
  expiresAt: '2099-01-01T00:00:00.000000Z',
  timezone: 'America/Edmonton',
  filters: { startDate: DAYS[0], endDate: DAYS[6], bin: 'day', profiles: 'all', metrics: ['saved_completions', 'settled_money',
    'contribution_distribution'] },
  range: { startDate: DAYS[0], endDate: DAYS[6] },
  bins: DAYS.map((d) => ({ id: d, startDate: d, endDate: d, partial: false })),
  profiles: [{ id: 3, name: 'Finn', archived: false }, { id: 2, name: 'Leo', archived: false }, { id: 1, name: 'Maya', archived: false }],
  metrics: [
    { key: 'saved_completions', label: 'Saved completions — as recorded by the person who saved it', unit: 'completions',
      basis: 'Each saved completion that was not undone, on the household-local date its saver recorded.' },
    { key: 'settled_money', label: 'Settled', unit: 'currency',
      basis: 'Settled payout items, on the household-local date of settlement, as exact decimals.' },
    { key: 'contribution_distribution', label: 'Recorded contributions', unit: 'per profile',
      basis: 'Per profile over the whole range, alphabetical by name. No assertion about equal work, difficulty or motivation.',
      series: [{ key: 'approved_xp', label: 'Approved XP' }] },
  ],
  rows: [
    ...DAYS.map((d, i) => row('saved_completions', d, SAVED[i])),
    ...DAYS.map((d, i) => ({ ...row('settled_money', d, SETTLED[i] ?? '0.00', { currency: 'CAD' }), id: `settled_money:CAD:${d}` })),
    ...[[3, 60], [2, 95], [1, 90]].map(([id, xp]) => ({ ...row('contribution_distribution', 'range', xp, { profileId: id }),
      id: `contribution_distribution:approved_xp:${id}`, series: 'approved_xp' })),
  ],
};

const FIXTURE_ACTIVITY = {
  enabled: true,
  metric: { key: 'approved_xp', coverage: 'full', label: 'Approved XP', unit: 'XP', startDate: DAYS[0], endDate: DAYS[6], timezone: 'America/Edmonton',
    basis: 'XP from quests a parent approved, placed on the household-local date of the approval.' },
  rows: [{ user_id: 3, first_name: 'Finn', avatar_url: null, approved_xp: 60 }, { user_id: 2, first_name: 'Leo', avatar_url: null, approved_xp: 95 },
    { user_id: 1, first_name: 'Maya', avatar_url: null, approved_xp: 90 }],
};

export const insightsFixture = {
  report: toReport(FIXTURE_SNAPSHOT),
  activity: toActivity(FIXTURE_ACTIVITY),
  exportNote: 'This is a preview, so there is nothing to download.',
  familyName: 'How the Silva family is doing',
  parentName: 'Sara',
  avatar: `${ASSET}/avatar-parent-1.jpg`,
  notifications: 3,
};
